import { GetServerSideProps } from 'next'
import React from 'react'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { withPublic } from '../src/component'
import { SignUpPage as SignUp } from '../src/page'
import { createCombinedServerSideProps } from '../src/utils/server/page-props'

const I18N_NAMESPACE = ['common', 'terminalError', 'signUp', 'login', 'password']

const SignUpPage: CheckoutPage = (props) => <SignUp {...props} />

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)

const SignUpPagePublic: CheckoutPage = withPublic(SignUpPage)
SignUpPagePublic.getLayout = getLayout()

export default SignUpPagePublic
